module.exports = __webpack_public_path__ + "img/re-swapp-visitor-icon.a7c5f622.png";